import { useMutation } from 'react-query';

import { adminToggleForumPostPinned } from '@utils/backend-api/forumPosts';

export default function useForumPostPinnedToggle() {
  const { mutate, mutateAsync, data, isLoading, isError } = useMutation((id: number) =>
    adminToggleForumPostPinned(id)
  );
  return { mutate, mutateAsync, data, isLoading, isError };
}
